import React from "react";
import { Wifi, WifiOff } from "lucide-react";
import { DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useApp } from "@/context/AppContext";

export default function ChatHeader({ counterparty, propertyTitle, wsStatus }) {
  const { lang } = useApp();
  const live = wsStatus === "live";
  return (
    <DialogHeader className="p-5 border-b border-[#D8CFBB] bg-[#F5F0E6]">
      <div className="flex items-center justify-between">
        <div className="min-w-0">
          <p className="text-[10px] tracking-[0.3em] uppercase text-[#C5A880] mb-1">
            {lang === "it" ? "Chat riservata" : "Private chat"}
          </p>
          <DialogTitle className="text-xl font-[Cormorant_Garamond,serif]" data-testid="chat-modal-title">
            {counterparty || "—"}
          </DialogTitle>
          <p className="text-xs text-[#7A6E5A] mt-1 truncate">{propertyTitle}</p>
        </div>
        <div
          className={`flex items-center gap-1.5 text-[10px] uppercase tracking-widest ${
            live ? "text-emerald-700" : "text-[#B8A98F]"
          }`}
          data-testid="chat-ws-status"
          title={wsStatus}
        >
          {live ? <Wifi className="w-3 h-3" /> : <WifiOff className="w-3 h-3" />}
          {live ? "live" : wsStatus}
        </div>
      </div>
    </DialogHeader>
  );
}
